var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("pages-header", {
        ref: "pageHeader",
        attrs: {
          title: _vm.$route.params.id
            ? _vm.$route.params.type && _vm.formValidate.id > 0
              ? "商品详情"
              : "编辑商品"
            : "添加商品",
          backUrl: "/marketing/bargain/bargainGoods",
        },
      }),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "list-tabs",
              on: { "tab-click": _vm.tabsHandleClick },
              model: {
                value: _vm.currentTab,
                callback: function ($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab",
              },
            },
            [
              !_vm.$route.params.id
                ? _c("el-tab-pane", { attrs: { label: "选择商品", name: "0" } })
                : _vm._e(),
              _c("el-tab-pane", { attrs: { label: "基础信息", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "商品详情", name: "2" } }),
            ],
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.fullscreenLoading,
                  expression: "fullscreenLoading",
                },
              ],
              ref: "formValidate",
              staticClass: "formValidate mt20",
              attrs: {
                rules: _vm.ruleValidate,
                model: _vm.formValidate,
                "label-width": "100px",
              },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 0 && !_vm.$route.params.id,
                      expression: "currentTab == 0 && !$route.params.id",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择商品：", prop: "image" } },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "upLoadPicBox",
                          on: { click: _vm.changeGood },
                        },
                        [
                          _vm.formValidate.image
                            ? _c("div", { staticClass: "pictrue" }, [
                                _c("img", {
                                  attrs: { src: _vm.formValidate.image },
                                }),
                              ])
                            : _c("div", { staticClass: "upLoad" }, [
                                _c("i", {
                                  staticClass: "el-icon-camera cameraIconfont",
                                }),
                              ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 1,
                      expression: "currentTab == 1",
                    },
                  ],
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "商品主图：", prop: "image" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "upLoadPicBox",
                                  on: {
                                    click: function ($event) {
                                      return _vm.modalPicTap("1")
                                    },
                                  },
                                },
                                [
                                  _vm.formValidate.image
                                    ? _c("div", { staticClass: "pictrue" }, [
                                        _c("img", {
                                          attrs: {
                                            src: _vm.formValidate.image,
                                          },
                                        }),
                                      ])
                                    : _c("div", { staticClass: "upLoad" }, [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-camera cameraIconfont",
                                        }),
                                      ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "商品轮播图：", prop: "images" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "acea-row" },
                                [
                                  _vm._l(
                                    _vm.formValidate.imagess,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "pictrue",
                                          attrs: { draggable: "true" },
                                          on: {
                                            dragstart: function ($event) {
                                              return _vm.handleDragStart(
                                                $event,
                                                item
                                              )
                                            },
                                            dragover: function ($event) {
                                              $event.preventDefault()
                                              return _vm.handleDragOver(
                                                $event,
                                                item
                                              )
                                            },
                                            dragenter: function ($event) {
                                              return _vm.handleDragEnter(
                                                $event,
                                                item
                                              )
                                            },
                                            dragend: function ($event) {
                                              return _vm.handleDragEnd(
                                                $event,
                                                item
                                              )
                                            },
                                          },
                                        },
                                        [
                                          item.split(".")[
                                            item.split(".").length - 1
                                          ] !== "mp4"
                                            ? _c("img", {
                                                attrs: { src: item },
                                              })
                                            : _c("video", {
                                                attrs: { src: item },
                                              }),
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.$route.params.type,
                                                expression:
                                                  "!$route.params.type",
                                              },
                                            ],
                                            staticClass: "el-icon-error btndel",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleRemove(index)
                                              },
                                            },
                                          }),
                                        ]
                                      )
                                    }
                                  ),
                                  _vm.formValidate.imagess.length < 10 &&
                                  !_vm.$route.params.type
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "upLoadPicBox",
                                          on: {
                                            click: function ($event) {
                                              return _vm.modalPicTap("2")
                                            },
                                          },
                                        },
                                        [
                                          _c("div", { staticClass: "upLoad" }, [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-camera cameraIconfont",
                                            }),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "砍价活动名称：", prop: "title" },
                            },
                            [
                              _c("el-input", {
                                staticClass: "selWidthd",
                                attrs: {
                                  disabled:
                                    Boolean(_vm.$route.params.type) &&
                                    _vm.formValidate.id > 0,
                                  maxlength: "249",
                                  placeholder: "请输入砍价活动名称",
                                },
                                model: {
                                  value: _vm.formValidate.title,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "title", $$v)
                                  },
                                  expression: "formValidate.title",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "单位：", prop: "unitName" } },
                            [
                              _c("el-input", {
                                staticClass: "selWidthd",
                                attrs: {
                                  disabled: Boolean(_vm.$route.params.type),
                                  placeholder: "请输入单位",
                                },
                                model: {
                                  value: _vm.formValidate.unitName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "unitName", $$v)
                                  },
                                  expression: "formValidate.unitName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "排序：", prop: "sort" } },
                            [
                              _c("el-input-number", {
                                staticClass: "selWidthd",
                                attrs: {
                                  disabled: Boolean(_vm.$route.params.type),
                                  step: 1,
                                  "step-strictly": "",
                                  "controls-position": "right",
                                  max: 9999,
                                  placeholder: "请输入排序",
                                },
                                model: {
                                  value: _vm.formValidate.sort,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "sort", $$v)
                                  },
                                  expression: "formValidate.sort",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "活动日期：", prop: "timeVal" } },
                            [
                              _c("el-date-picker", {
                                staticClass: "mr20 selWidthd",
                                attrs: {
                                  disabled: Boolean(_vm.$route.params.type),
                                  type: "daterange",
                                  "value-format": "yyyy-MM-dd",
                                  format: "yyyy-MM-dd",
                                  "range-separator": "-",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  "picker-options": _vm.pickerOptions,
                                },
                                on: { change: _vm.onchangeTime },
                                model: {
                                  value: _vm.formValidate.timeVal,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "timeVal", $$v)
                                  },
                                  expression: "formValidate.timeVal",
                                },
                              }),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v(
                                  "设置活动开启结束时间，用户可以在设置时间内发起参与砍价"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "砍价人数：", prop: "peopleNum" },
                            },
                            [
                              _c("el-input-number", {
                                staticClass: "selWidthd mr20",
                                attrs: {
                                  "controls-position": "right",
                                  disabled: Boolean(_vm.$route.params.type),
                                  min: 2,
                                  step: 1,
                                  "step-strictly": "",
                                  placeholder: "请输入砍价人数",
                                },
                                model: {
                                  value: _vm.formValidate.peopleNum,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "peopleNum", $$v)
                                  },
                                  expression: "formValidate.peopleNum",
                                },
                              }),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v("需邀请多少人砍价成功"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "帮砍次数：",
                                prop: "bargainNum",
                              },
                            },
                            [
                              _c("el-input-number", {
                                staticClass: "selWidthd mr20",
                                attrs: {
                                  disabled: Boolean(_vm.$route.params.type),
                                  "controls-position": "right",
                                  min: 1,
                                  step: 1,
                                  "step-strictly": "",
                                  placeholder: "请输入帮砍次数",
                                },
                                model: {
                                  value: _vm.formValidate.bargainNum,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formValidate,
                                      "bargainNum",
                                      $$v
                                    )
                                  },
                                  expression: "formValidate.bargainNum",
                                },
                              }),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v(
                                  " 单个商品用户可以帮砍的次数，例：次数设置为1，甲和乙同时将商品A的砍价链接发给丙，丙只能帮甲或乙其中一个人砍价 "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "购买数量限制：", prop: "num" } },
                            [
                              _c("el-input-number", {
                                staticClass: "selWidthd mr20",
                                attrs: {
                                  disabled: Boolean(_vm.$route.params.type),
                                  "controls-position": "right",
                                  min: 1,
                                  step: 1,
                                  "step-strictly": "",
                                  placeholder: "请输入购买数量限制",
                                },
                                model: {
                                  value: _vm.formValidate.num,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formValidate, "num", $$v)
                                  },
                                  expression: "formValidate.num",
                                },
                              }),
                              _c("div", { staticClass: "from-tips" }, [
                                _vm._v("单个活动每个用户发起砍价次数限制"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        _vm._b({}, "el-col", _vm.grid2, false),
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "运费模板：", prop: "tempId" } },
                            [
                              _c(
                                "div",
                                { staticClass: "acea-row" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "selWidthd",
                                      attrs: {
                                        disabled: Boolean(
                                          _vm.$route.params.type
                                        ),
                                        placeholder: "请选择",
                                      },
                                      model: {
                                        value: _vm.formValidate.tempId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formValidate,
                                            "tempId",
                                            $$v
                                          )
                                        },
                                        expression: "formValidate.tempId",
                                      },
                                    },
                                    _vm._l(_vm.shippingList, function (item) {
                                      return _c("el-option", {
                                        key: item.id,
                                        attrs: {
                                          label: item.name,
                                          value: item.id,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "活动状态：", required: "" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  attrs: {
                                    disabled: Boolean(_vm.$route.params.type),
                                  },
                                  model: {
                                    value: _vm.formValidate.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formValidate, "status", $$v)
                                    },
                                    expression: "formValidate.status",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio",
                                    {
                                      staticClass: "radio",
                                      attrs: { label: 0 },
                                    },
                                    [_vm._v("关闭")]
                                  ),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("开启"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "labeltop",
                              attrs: { label: "商品属性：", required: "" },
                            },
                            [
                              _c(
                                "el-table",
                                {
                                  ref: "multipleTable",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    data: _vm.ManyAttrValue,
                                    "tooltip-effect": "dark",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "选择", width: "70" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: {
                                                  disabled: Boolean(
                                                    _vm.$route.params.type
                                                  ),
                                                  label: scope.row,
                                                },
                                                nativeOn: {
                                                  change: function ($event) {
                                                    return _vm.changeType(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: _vm.radio,
                                                  callback: function ($$v) {
                                                    _vm.radio = $$v
                                                  },
                                                  expression: "radio",
                                                },
                                              },
                                              [_vm._v(_vm._s(""))]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _vm.manyTabDate && _vm.formValidate.specType
                                    ? _vm._l(
                                        _vm.manyTabDate,
                                        function (item, iii) {
                                          return _c("el-table-column", {
                                            key: iii,
                                            attrs: {
                                              label: _vm.manyTabTit[iii].title,
                                              "min-width": "80",
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (scope) {
                                                    return [
                                                      _c("span", {
                                                        staticClass: "priceBox",
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            scope.row[iii]
                                                          ),
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          })
                                        }
                                      )
                                    : _vm._e(),
                                  _c("el-table-column", {
                                    attrs: { label: "图片", "min-width": "80" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "upLoadPicBox",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.modalPicTap(
                                                      "1",
                                                      "duo",
                                                      scope.$index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                scope.row.image
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pictrue tabPic",
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: scope.row
                                                              .image,
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "upLoad tabPic",
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-camera cameraIconfont",
                                                        }),
                                                      ]
                                                    ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                  }),
                                  _vm._l(_vm.attrValue, function (item, iii) {
                                    return _c("el-table-column", {
                                      key: iii,
                                      attrs: {
                                        label: _vm.formThead[iii].title,
                                        "min-width": "150",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var row = ref.row
                                              var $index = ref.$index
                                              return [
                                                _vm.formThead[iii].title ===
                                                "砍价起始金额"
                                                  ? _c("el-input-number", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        disabled: Boolean(
                                                          _vm.$route.params.type
                                                        ),
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        min: 0,
                                                        precision: 2,
                                                        step: 0.1,
                                                      },
                                                      model: {
                                                        value: row[iii],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row,
                                                            iii,
                                                            $$v
                                                          )
                                                        },
                                                        expression: "row[iii]",
                                                      },
                                                    })
                                                  : _vm.formThead[iii].title ===
                                                    "砍价最低价"
                                                  ? _c("el-input-number", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        disabled: Boolean(
                                                          _vm.$route.params.type
                                                        ),
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        min: 0,
                                                        max: parseFloat(
                                                          row.price
                                                        ),
                                                        precision: 2,
                                                        step: 0.1,
                                                      },
                                                      model: {
                                                        value: row[iii],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row,
                                                            iii,
                                                            $$v
                                                          )
                                                        },
                                                        expression: "row[iii]",
                                                      },
                                                    })
                                                  : _vm.formThead[iii].title ===
                                                    "限量"
                                                  ? _c("el-input-number", {
                                                      staticClass: "priceBox",
                                                      attrs: {
                                                        disabled: Boolean(
                                                          _vm.$route.params.type
                                                        ),
                                                        "controls-position":
                                                          "right",
                                                        size: "small",
                                                        type: "number",
                                                        min: _vm.minQuota(row),
                                                        max: row.stock,
                                                        step: 1,
                                                        "step-strictly": "",
                                                      },
                                                      model: {
                                                        value: row[iii],
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row,
                                                            iii,
                                                            $$v
                                                          )
                                                        },
                                                        expression: "row[iii]",
                                                      },
                                                    })
                                                  : _c("span", {
                                                      staticClass: "priceBox",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          row[iii]
                                                        ),
                                                      },
                                                    }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    })
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.currentTab == 2,
                      expression: "currentTab == 2",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品详情：" } },
                    [
                      !_vm.$route.params.type
                        ? _c("Tinymce", {
                            model: {
                              value: _vm.formValidate.content,
                              callback: function ($$v) {
                                _vm.$set(_vm.formValidate, "content", $$v)
                              },
                              expression: "formValidate.content",
                            },
                          })
                        : _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.formValidate.content),
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { staticStyle: { "margin-top": "30px" } },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            (!_vm.$route.params.id && _vm.currentTab > 0) ||
                            (_vm.$route.params.id && _vm.currentTab == 2),
                          expression:
                            "(!$route.params.id && currentTab > 0) || ($route.params.id && currentTab == 2)",
                        },
                      ],
                      staticClass: "submission",
                      attrs: { size: "small" },
                      on: { click: _vm.handleSubmitUp },
                    },
                    [_vm._v("上一步")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab == 0,
                          expression: "currentTab == 0",
                        },
                      ],
                      staticClass: "submission onePrimary",
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitNest1("formValidate")
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentTab == 1,
                          expression: "currentTab == 1",
                        },
                      ],
                      staticClass: "submission",
                      attrs: { size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmitNest2("formValidate")
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.$route.params.type,
                          expression: "!$route.params.type",
                        },
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:bargain:update"],
                          expression: "['admin:bargain:update']",
                        },
                      ],
                      staticClass: "submission",
                      attrs: {
                        loading: _vm.loading,
                        type: "primary",
                        size: "small",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("formValidate")
                        },
                      },
                    },
                    [_vm._v("提交")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("CreatTemplates", {
        ref: "addTemplates",
        on: { getList: _vm.getShippingList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }